import { MessageDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { clearAnalyticsUser } from "@/client/libs/analytics";
import { queryClient } from "@/client/libs/query-client";
import { useAiStore } from "@/client/stores/ai";
import { useAuthStore } from "@/client/stores/auth";

export const deleteUser = async () => {
  const response = await axios.delete<MessageDto, AxiosResponse<MessageDto>>("/user/me");

  return response.data;
};

export const useDeleteUser = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: deleteUserFn,
  } = useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      clearAnalyticsUser();
      useAiStore.getState().unbindUser();
      useAuthStore.getState().setUser(null);
      queryClient.clear();
    },
  });

  return { deleteUser: deleteUserFn, loading, error };
};
